import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MenuModule } from 'primeng/menu';
import { MenuItem } from 'primeng/api';
import { LayoutService } from './service/layout.service';

@Component({
  selector: 'app-topbar',
  standalone: true,
  imports: [RouterModule, MenuModule],
  template: `<div class="layout-topbar">
    <div class="layout-topbar-logo-container">
      <button
        type="button"
        class="layout-menu-button layout-topbar-action"
        (click)="layoutService.onMenuToggle()"
        aria-label="Toggle menu"
      >
        <i class="pi pi-bars"></i>
      </button>
      <a class="layout-topbar-logo" routerLink="/">
        <span>{{ layoutService.appTitle() }}</span>
      </a>
    </div>

    <div class="layout-topbar-actions">
      <button
        type="button"
        class="layout-topbar-action"
        (click)="userMenu.toggle($event)"
        aria-label="Menú de usuario"
        aria-haspopup="true"
      >
        <i class="pi pi-user"></i>
      </button>
      <p-menu
        #userMenu
        [model]="userMenuItems"
        [popup]="true"
        appendTo="body"
      ></p-menu>
    </div>
  </div>`,
})
export class AppTopbar {
  layoutService = inject(LayoutService);

  // User account menu (extensible: future account actions append here).
  readonly userMenuItems: MenuItem[] = [
    {
      label: 'Mi perfil',
      icon: 'pi pi-user',
      routerLink: '/accounts/profile',
    },
    {
      label: 'Cerrar sesión',
      icon: 'pi pi-sign-out',
      command: () => {
        this.onLogout();
      },
    },
  ];

  onLogout() {
    this.layoutService.logoutRequested$.next();
  }
}
